import React, { useState } from "react";
import toast from "react-hot-toast";

// Helper function to generate a unique ID (for demonstration purposes)
const generateId = () => Math.random().toString(36).substring(2, 9);

const getFirstLastInitials = (fullName) => {
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  const first = parts[0].charAt(0).toUpperCase();
  const last = parts[parts.length - 1].charAt(0).toUpperCase();
  return first + last;
};

// Comment component
const Comment = ({ avatarUrl, author, timestamp, text }) => {
  return (
    <div className="flex items-start space-x-4 p-4 bg-gray-50 rounded-lg shadow-sm mb-4">
      {/* Avatar */}
      <img
        src={
          avatarUrl ||
          `https://placehold.co/40x40/E0E0E0/808080?text=${getFirstLastInitials(
            author
          )}`
        }
        alt={`${author}'s avatar`}
        className="w-10 h-10 rounded-full object-cover border-2 border-gray-300"
        onContextMenu={(e) => e.preventDefault()}
        // onError={(e) => { e.target.onerror = null; e.target.src = `https://placehold.co/40x40/E0E0E0/808080?text=${author.charAt(0)}`; }}
      />
      <div className="flex-1">
        {/* Author and Timestamp */}
        <div className="flex items-center justify-between mb-1">
          <p className="font-semibold text-gray-800">{author}</p>
          <span className="text-sm text-gray-500">{timestamp}</span>
        </div>
        {/* Comment Text */}
        <p className="text-gray-700 leading-relaxed">{text}</p>
      </div>
    </div>
  );
};

// Comment Section component
export const CommentSection = () => {
  const [comments, setComments] = useState([
    {
      id: generateId(),
      author: "Mame Diarra",
      avatarUrl: "https://placehold.co/40x40/e6bfad/000000?text=MD", // Example placeholder
      timestamp: "Il y'a 2 heures",
      text: "Je n’ai plus peur de m’épiler, ça prend 5 minutes, je rince et c’est nickel. Fini les coupures de rasoir.",
    },
    {
      id: generateId(),
      author: "Faty Diop",
      avatarUrl:
        "https://newhackerway.blob.core.windows.net/thumbnails/9.png?sp=r&st=2025-07-09T12:36:55Z&se=2029-07-09T20:36:55Z&sv=2024-11-04&sr=b&sig=icX9l%2FFCvZr5XPPcyRKupLxpbaV7TVsDjoKs%2BPBkoNY%3D", // Example placeholder
      timestamp: "Il y'a 2 heures",
      text: "Je l’ai testé sur les jambes, le résultat est propre, doux et sans rougeurs. Top franchement.",
    },
    {
      id: generateId(),
      author: "Cheikh Sambou",
      avatarUrl: "https://placehold.co/40x40/ade6d0/000000?text=CS", // Example placeholder
      timestamp: "Il y'a 30 minutes",
      text: "Je pensais que c’était une arnaque, mais non ! Les poils sont partis en quelques minutes, et ma peau est restée douce.",
    },
    {
      id: generateId(),
      author: "Yacine Touré",
      avatarUrl:
        "https://newhackerway.blob.core.windows.net/thumbnails/34.png?sp=r&st=2025-07-03T12:58:05Z&se=2029-07-03T20:58:05Z&sv=2024-11-04&sr=b&sig=SBfoo1hIjBxtOy2lZUtiMDJIGiLTCjBYsic%2F%2Bc6obOE%3D", // Example placeholder
      timestamp: "Il y'a 5 minutes",
      text: "Rapide, efficace, et surtout pratique. J’en ai toujours un dans ma trousse de toilette maintenant.",
    },
    {
      id: generateId(),
      author: "Mame Ngom",
      avatarUrl:
        "https://newhackerway.blob.core.windows.net/thumbnails/36.png?sp=r&st=2025-07-03T12:54:35Z&se=2029-07-03T20:54:35Z&sv=2024-11-04&sr=b&sig=17MO1xDZDp9x409FxqDfloLiYsGXkyqxnq581EtglxI%3D", // Example placeholder
      timestamp: "Tout de suite",
      text: "Je l’utilise avant les sorties, ça me sauve la vie quand je suis pressée. Pas de douleur, pas de brûlure.",
    },
  ]);
  const [newCommentText, setNewCommentText] = useState("");
  const [newCommentAuthor, setNewCommentAuthor] = useState("");

  // Function to handle adding a new comment
  const handleAddComment = (e) => {
    e.preventDefault(); // Prevent default form submission
    if (newCommentText.trim() === "") {
      // In a real app, you'd show a custom modal or message here, not alert
      toast("Commentaire vide...");
      return;
    }

    const now = new Date();
    const timestamp = now.toLocaleString(); // Format date nicely

    const newComment = {
      id: generateId(),
      author: newCommentAuthor.trim() || "Anonymous", // Use 'Anonymous' if author is empty
      avatarUrl: "", // Can be dynamically generated or left empty for default
      timestamp: timestamp,
      text: newCommentText.trim(),
    };

    setComments([...comments, newComment]); // Add new comment to the list
    setNewCommentText(""); // Clear the text area
    setNewCommentAuthor("Samba Ba"); // Reset author to default
  };

  return (
    <div className="bg-white p-8 rounded-xl shadow-2xl max-w-2xl w-full animate-fade-in-up">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Commentaires</h2>
      {/* Comment List */}
      <div className="max-h-96 overflow-y-auto pr-2 custom-scrollbar">
        {" "}
        {/* Added custom-scrollbar for better UX */}
        {comments.map((comment) => (
          <Comment
            key={comment.id}
            avatarUrl={comment.avatarUrl}
            author={comment.author}
            timestamp={comment.timestamp}
            text={comment.text}
          />
        ))}
      </div>

      {/* Add New Comment Form */}
      <form
        onSubmit={handleAddComment}
        className="mt-6 pt-6 border-t border-gray-200"
      >
        <h3 className="text-xl font-semibold text-gray-800 mb-4">
          Faire un commentaire
        </h3>
        <div className="mb-4">
          <label
            htmlFor="authorName"
            className="block text-gray-700 text-sm font-bold mb-2"
          >
            Entrer votre Nom:
          </label>
          <input
            type="text"
            id="authorName"
            value={newCommentAuthor}
            onChange={(e) => setNewCommentAuthor(e.target.value)}
            placeholder="e.g., Samba Ba"
            className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-transparent transition duration-200 ease-in-out"
          />
        </div>
        <div className="mb-4">
          <label
            htmlFor="commentText"
            className="block text-gray-700 text-sm font-bold mb-2"
          >
            Votre Commentaire:
          </label>
          <textarea
            id="commentText"
            value={newCommentText}
            onChange={(e) => setNewCommentText(e.target.value)}
            placeholder="Ecrivez votre commentaire ici..."
            rows={4}
            className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-transparent transition duration-200 ease-in-out resize-y"
          ></textarea>
        </div>
        <button
          type="submit"
          className="w-full bg-black text-white font-bold py-3 px-6 rounded-lg shadow-lg transform transition duration-300 ease-in-out hover:scale-105 focus:outline-none focus:ring-4 focus:ring-djeliba"
        >
          Soumettre
        </button>
      </form>
    </div>
  );
};
